import React, { FC } from 'react';

import styled, { keyframes } from 'styled-components';

import Confetti from '../../../../assets/confetti';

// using rbga(0,0,0,0) for transparent here causes display issue in Safari + iOS - https://css-tricks.com/thing-know-gradients-transparent-black/
export const LIGHT_BRAND_COLOR_TRANSPARENT = `rgba(213, 23, 60, 0)`;
export const LIGHT_BRAND_COLOR = `rgba(213, 23, 60, 1)`;

export const DARK_BRAND_COLOR = `#910018`;
const explode = keyframes`
  from {
    opacity: 0;
    transform: scale(0.3, 0.3) translateY(-50%)
  } to {
    opacity: 1;
    transform: scale(1, 1) translateY(0);
  }
`;

/**
 * Styled background for TH Rollup game screens.
 *
 * The background fills its parent and must be wrapped in a parent that fills the screen if that is the goal.
 *
 * Layered gradients create soft spotlight effect without an obvious
 * radial gradient.
 */
export const GameplayBackgroundGradient = styled.div`
  min-height: 100%;
  width: 100%;
  background: linear-gradient(
      ${LIGHT_BRAND_COLOR_TRANSPARENT} 0%,
      ${LIGHT_BRAND_COLOR},
      ${LIGHT_BRAND_COLOR_TRANSPARENT} 80%
    ),
    radial-gradient(
      circle farthest-side,
      ${LIGHT_BRAND_COLOR} 30%,
      ${LIGHT_BRAND_COLOR_TRANSPARENT} 100%
    ),
    ${DARK_BRAND_COLOR};
`;
const FADE_IN_TIME = 1000;
const ConfettiContainer = styled.div`
  position: absolute;
  overflow: hidden;
  width: 100%;
  height: auto;
  /* TODO this is only necessary because the SVG is not cropped.
     If we crop the SVG we can remove this
   */
  top: 38px;
  animation: ${explode} forwards ${FADE_IN_TIME / 1000}s;
  pointer-events: none;
`;

const Content = styled.div`
  /* necessary for z-index positioning */
  position: relative;
  height: 100%;
  color: ${Styles.color.white};
`;

interface GameplayBackgroundProps {
  /**
   * Show the confetti overlay
   *
   * @default undefined
   **/
  showConfetti?: boolean;
  className?: string;
}

export const GameplayBackground: FC<GameplayBackgroundProps> = ({
  showConfetti = true,
  children,
  className,
}) => {
  return (
    <GameplayBackgroundGradient className={className} data-testid="gameplay-background">
      {showConfetti && (
        <ConfettiContainer>
          <Confetti />
        </ConfettiContainer>
      )}
      <Content>{children}</Content>
    </GameplayBackgroundGradient>
  );
};

export default GameplayBackground;
